import { render } from "./ValidateIdentity.vue?vue&type=template&id=0066d4a7"
import script from "./ValidateIdentity.vue?vue&type=script&lang=js"
export * from "./ValidateIdentity.vue?vue&type=script&lang=js"

import "./ValidateIdentity.vue?vue&type=style&index=0&id=0066d4a7&lang=css"
script.render = render

export default script